"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inspection270DayResult = void 0;
var Inspection270DayResult;
(function (Inspection270DayResult) {
    Inspection270DayResult["Built"] = "Structure has been built";
    Inspection270DayResult["NotBuilt"] = "No structure built on permit site";
})(Inspection270DayResult || (exports.Inspection270DayResult = Inspection270DayResult = {}));
;
